/* js-base index.ts */
export * from './auth';
async function saveFileDownload(response, filename) {
    const b = await response.blob();
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // MS Edge support
        window.navigator.msSaveOrOpenBlob(b, filename);
    }
    else {
        const blobUrl = window.URL.createObjectURL(b);
        let a = document.createElement('a');
        if (typeof a.download === 'undefined') {
            window.location.href = blobUrl;
        }
        else {
            // HACK: creates an invisible download link and clicks it. (The alternative is opening the url in a popup, but those are generally blocked)
            document.body.appendChild(a);
            a.style.display = 'none';
            a.href = blobUrl;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(blobUrl);
            document.body.removeChild(a);
        }
    }
}
function delayAsync(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
import Events from './events';
export { Events, saveFileDownload, delayAsync };
//# sourceMappingURL=index.js.map